export default [
  {
    path: '/inventory',
    name: 'inventory-dashboard',
    component: () => import('@/views/inventory/Index.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Inventaire',
      breadcrumb: [
        {
          text: 'Inventaire',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator'],
    },
  },
  {
    path: '/inventory/history',
    name: 'inventory-history',
    component: () => import('@/views/inventory/History.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Historique des inventaires',
      breadcrumb: [
        {
          text: 'Inventaire',
          to: '/inventory',
        },
        {
          text: 'Historique',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator'],
    },
  },
]
